import React from 'react';
import './AboutUsPage.css';

const AboutUsPage = ({ data }) => {
    return (
        <section className="about-us-page section" id={data.id}>
            <div className="container">
                <div className="section-title">
                    <h2>{data.title}</h2>
                </div>

                {/* Organization Details */}
                <div className="organization-details">
                    <h3 className="org-name">{data.organizationName}</h3>
                    <div className="org-info">
                        <p><strong>ABN:</strong> {data.abn}</p>
                        <p><strong>Registration No:</strong> {data.registrationNo}</p>
                    </div>
                </div>

                {/* Vision and Mission */}
                <div className="vision-mission-grid">
                    <div className="vm-card vision-card">
                        <div className="vm-icon">
                            <i className="fas fa-eye"></i>
                        </div>
                        <h3>{data.vision.title}</h3>
                        <p>{data.vision.content}</p>
                    </div>

                    <div className="vm-card mission-card">
                        <div className="vm-icon">
                            <i className="fas fa-bullseye"></i>
                        </div>
                        <h3>{data.mission.title}</h3>
                        <p>{data.mission.content}</p>
                    </div>
                </div>

                {/* Objectives */}
                <div className="objectives-section">
                    <h3>Our Objectives</h3>
                    <div className="objectives-grid">
                        {data.objectives.map((objective, index) => (
                            <div key={index} className="objective-item">
                                <i className="fas fa-check-circle"></i>
                                <p>{objective}</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default AboutUsPage;
